import { Button, Heading, Icon, IconButton, Select, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";

import { FaArrowLeft, FaArrowRight, FaCheck, FaUserCog } from "react-icons/fa";




export default function UserRoles() {
    const [invs] = useState([
        {
            viewType: 'Button',
            viewName: 'Assign Org Owner'
        },
        {
            viewType: 'Button',
            viewName: 'Manage Entity Integration'
        },
        {
            viewType: 'Button',
            viewName: 'Assign Org Owner'
        },
        {
            viewType: 'Button',
            viewName: 'Integration XERO'
        },
        {
            viewType: 'Button',
            viewName: 'Integration Save'
        },
        {
            viewType: 'Button',
            viewName: 'Integration Change'
        },
        {
            viewType: 'Button',
            viewName: 'Integration Data Sync'
        },
        {
            viewType: 'Button',
            viewName: 'Integration Disconnect'
        },
        {
            viewType: 'Button',
            viewName: 'Integration QB Online'
        }
    ]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaUserCog}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>User Roles</Heading>
                            <Text fontSize={'sm'}>Here you can assign and view all user roles.</Text>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <Stack
                    w={'full'}
                    spacing={2}
                    align={'center'}
                    direction={'row'}
                    justify={'space-between'}
                >
                    <Select
                        size={'sm'}
                        w={'sm'}
                    >
                        <option value="option1">Organization Admin</option>
                        <option value="option2">Business Admin</option>
                        <option value="option3">Business User</option>
                        <option value="option3">Data Entry Operator</option>
                        <option value="option3">Data Entry Supervisor</option>
                        <option value="option3">Organization Account Owner</option>
                        <option value="option3">Organization User</option>
                        <option value="option3">Management User</option>
                        <option value="option3">Limited access (data uploaded by user)</option>
                    </Select>

                    <Button
                        size={'sm'}
                        color={'white'}
                        bg={'green.500'}
                        leftIcon={<FaCheck />}
                        _hover={{ bg: 'green.600' }}
                        _active={{ bg: 'green.700' }}
                    >
                        Submit
                    </Button>
                </Stack>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'} zIndex={1}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    View Type
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    View Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Rights Type
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.map((inv, i) => (
                                    <Tr>
                                        <Td>{inv.viewType}</Td>
                                        <Td>{inv.viewName}</Td>
                                        <Td>
                                            <Select 
                                                w={'full'} 
                                                size={'sm'}
                                            >
                                                <option value={'option1'}>No</option>
                                                <option value={'option2'}>Yes</option>
                                            </Select>
                                        </Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}